// Payment Service for ClearPE Integration
const API_BASE_URL = 'https://backend.mainbazar777.site/api';

/**
 * Create a payment order
 * @param {number} userId - User ID
 * @param {number} amount - Amount to pay
 * @returns {Promise} Response with payment_url and txn_id
 */
export const createOrder = async (userId, amount) => {
  try {
    const response = await fetch(`${API_BASE_URL}/wallet-create-order`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        user_id: userId,
        amount: amount,
        web:'milan'
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (!data.success) {
      throw new Error(data.message || 'Failed to create order');
    }

    return data;
  } catch (error) {
    throw new Error(`Error creating order: ${error.message}`);
  }
};

/**
 * Check payment status
 * @param {string} orderId - Order ID
 * @returns {Promise} Response with status (0=pending, 1=success, 2=failed)
 */
export const checkPaymentStatus = async (orderId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/wallet-check-status`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        order_id: orderId,
      }),
    });
    console.log('Checking payment status for order:', orderId);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    throw new Error(`Error checking status: ${error.message}`);
  }
};

/**
 * Store order details in localStorage
 */
export const storeOrderInLocalStorage = (orderId, txnId, amount) => {
  const orderData = {
    orderId,
    txnId,
    amount,
    createdAt: new Date().toISOString(),
  };
  localStorage.setItem('pendingPaymentOrder', JSON.stringify(orderData));
};

/**
 * Get pending order from localStorage
 */
export const getPendingOrderFromLocalStorage = () => {
  const data = localStorage.getItem('pendingPaymentOrder');
  return data ? JSON.parse(data) : null;
};

/**
 * Clear pending order from localStorage
 */
export const clearPendingOrderFromLocalStorage = () => {
  localStorage.removeItem('pendingPaymentOrder');
};

/**
 * Fetch amount details (minimum deposit, withdrawal, payment method)
 * @returns {Promise} Response with minimum_deposit, minimum_withdrawal, payment_method
 */
export const fetchAmountDetails = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/fetch-amount-details`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error(`Error fetching amount details: ${error.message}`);
  }
};

/**
 * Request withdrawal
 * @param {number} userId - User ID
 * @param {number} amount - Amount to withdraw
 * @param {string} method - Withdrawal method (bank or upi)
 * @returns {Promise} Response with withdrawal status
 */
export const requestWithdrawal = async (userId, amount, method) => {
  try {
    const response = await fetch(`${API_BASE_URL}/withdrawal`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: userId,
        amount: amount,
        request_method: method,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error(`Error requesting withdrawal: ${error.message}`);
  }
};

/**
 * Fetch withdrawal history
 * @param {number} userId - User ID
 * @returns {Promise} Response with withdrawals array
 */
export const fetchWithdrawalHistory = async (userId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/withdrawal/users`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: userId,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error(`Error fetching withdrawal history: ${error.message}`);
  }
};
